<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('crudSimCards.messages.systemMessage') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{ messageDismissButton }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="deleteFromDatabase">{{ messageConfirmButton }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <merus-data-table
      :headers="headers"
      :items="simCards"
      :search="search"
      :loading="loadingtable"
      :loading-text="$t('crudSimCards.loading')"
      dense
      class="elevation-7"
      locale="pt"
      style="border-radius: 10px"
      :default-multi-sort="defaultSort"
    

 cod-tabela="SIMCARDS" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <cadastro-toolbar
          :title="$t('crudSimCards.title')"
          :token="token"
          :items="simCards"
          csv-title="sim_cards"
          @search="search = $event"
        >
          <template v-slot:add>
            <v-dialog v-model="dialog" max-width="100%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-toolbar dark color="primary" ref="myToolbar">
                  <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="save">{{ $t('button.save') }}</v-btn>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <v-row style="padding-top: 10px" justify="center">
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.iccid"
                            :label="$t('crudSimCards.form.fields.iccid')"
                            :rules="[iccidRules]"
                            clearable
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.numero"
                            :label="$t('crudSimCards.form.fields.numero')"
                            clearable
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.operadora"
                            :label="$t('crudSimCards.form.fields.operadora')"
                            clearable
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.status"
                            :label="$t('crudSimCards.form.fields.status')"
                            clearable
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.status_conexao"
                            :label="$t('crudSimCards.form.fields.statusConexao')"
                            clearable
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.imei"
                            :label="$t('crudSimCards.form.fields.imei')"
                            clearable
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.apn"
                            :label="$t('crudSimCards.form.fields.apn')"
                            clearable
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.consumo"
                            :label="$t('crudSimCards.form.fields.consumo')"
                            clearable
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </cadastro-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="green" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="red" @click="confirmDelete(item)">mdi-delete</v-icon>
      </template>
    </merus-data-table>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import { validador } from "@/constants";
import EventBus from "@/utils/eventBus";
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';

export default {
  name: 'CRUDSimCards',
  components: {
    MerusDataTable,
    CadastroToolbar,
  },
  data: () => ({
    headers: [],
    user: null,
    token: null,
    showConfirmButton: true,
    formValidado: true,
    dialog: false,
    operacao: 0,
    confirmDialog: false,
    mensagemdialog: "",
    loadingtable: true,
    search: "",
    simCards: [],
    editedIndex: -1,
    editedItem: {
      id_sim_card: null,
      iccid: null,
      numero: null,
      operadora: null,
      status: null,
      status_conexao: null,
      imei: null,
      apn: null,
      consumo: null,
    },
    deletedItem: null,
    defaultItem: {
      id_sim_card: null,
      iccid: null,
      numero: null,
      operadora: null,
      status: null,
      status_conexao: null,
      imei: null,
      apn: null,
      consumo: null,
    },
  }),
  computed: {
    messageDismissButton() { return this.$t('button.dismiss'); },
    messageConfirmButton() { return this.$t('button.confirm'); },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('crudSimCards.form.title.create')
        : this.$t('crudSimCards.form.title.edit');
    },
    defaultSort() {
      return [
        { value: 'iccid', options: { text: this.$t('system.labels.increasing'), value: 1 } }];
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user") || "null");
    this.token = sessionStorage.getItem("api");
    this.loadSimCards();
  },
  methods: {

    iccidRules() {
      if (!validador(this.editedItem.iccid, 1, 22, 1, 1)) {
        return this.$t('crudSimCards.form.validation.iccidRequired');
      }
      return true;
    },
    loadSimCards() {
      apiController.request(apiController.endpoints.getallSimcards, {
        onSuccess: (response) => {
          this.simCards = response.data || [];
          this.loadingtable = false;
        },
        onError: () => {
          this.loadingtable = false;
        },
      });
    },
    editItem(item) {
      this.editedIndex = this.simCards.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    confirmDelete(item) {
      this.deletedItem = item;
      this.mensagemdialog = this.$t('crudSimCards.messages.confirmDelete', { iccid: item.iccid || item.id_sim_card });
      this.showConfirmButton = true;
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      if (!this.deletedItem) {
        this.confirmDialog = false;
        return;
      }
      this.operacao = 2;
      apiController.request(apiController.endpoints.deleteSimcard, {
        data: { id_sim_card: this.deletedItem.id_sim_card },
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
        onError: () => {
          this.confirmDialog = false;
        },
      });
      this.deletedItem = null;
      this.confirmDialog = false;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },
    save() {
      this.$refs.form.validate();
      if (this.formValidado) {
        const payload = {
          iccid: this.editedItem.iccid || null,
          numero: this.editedItem.numero || null,
          operadora: this.editedItem.operadora || null,
          status: this.editedItem.status || null,
          status_conexao: this.editedItem.status_conexao || null,
          imei: this.editedItem.imei || null,
          apn: this.editedItem.apn || null,
          consumo: this.editedItem.consumo || null,
        };
        if (this.editedIndex === -1) {
          this.operacao = 0;
          apiController.request(apiController.endpoints.insertSimcard, {
            data: payload,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        } else {
          payload.id_sim_card = this.editedItem.id_sim_card;
          this.operacao = 1;
          apiController.request(apiController.endpoints.updateSimcard, {
            data: payload,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        }
      }
    },
    updateTable(status) {
      let mensagem = "";
      const tipo = status ? "error" : "success";

      if (status) {
        if (this.operacao === 0) {
          mensagem = this.$t('crudSimCards.messages.errorInclusion');
        } else if (this.operacao === 1) {
          mensagem = this.$t('crudSimCards.messages.errorUpdate');
        } else {
          mensagem = this.$t('crudSimCards.messages.errorDeletion');
        }
      } else {
        if (this.operacao === 0) {
          mensagem = this.$t('crudSimCards.messages.includedSuccess');
        } else if (this.operacao === 1) {
          mensagem = this.$t('crudSimCards.messages.updatedSuccess');
        } else {
          mensagem = this.$t('crudSimCards.messages.deletedSuccess');
        }
        this.editedItem = Object.assign({}, this.defaultItem);
      }

      EventBus.$emit('show-alert', { mensagem, tipo });
      this.close();
      this.loadSimCards();
    },
  },
};
</script>
